import React from 'react'
import { Country } from '../../graphql/api/types'

const countriesContext = React.createContext<ReadonlyArray<Country>>([])

countriesContext.displayName = 'CountriesContext'

export { countriesContext as CountriesContext }
